import { getReplaceDomain } from '@/compositions/useGetCountryCode';
import { isPartyHero } from '@/common/utils';

const pearConfigEnv = import.meta.env.VITE_BUILD_ENV === 'prod' ? 'prod' : 'gray';

const prefixMap = {
  gray: 'gray-',
  prod: '',
};

const fetchData = async (url: string) => {
  const res = await fetch(url);
  const data = await res.json();
  return data;
};

/**
 * 对文本进行关键词替换
 */
const doReplacement = (text: string, replacement: Record<string, string>): string => {
  let _text = text;
  Object.keys(replacement).forEach((key) => {
    // 大小写不敏感 都会被匹配到
    _text = _text.replace(new RegExp(key, 'gi'), replacement[key]);
  });
  return _text;
};

/**
 * 补充处理 BIGO 文案，将其替换为 PartyHero
 */
const applyBigoToPartyHeroReplace = (langs: Record<string, string>): Record<string, string> => {
  if (!isPartyHero()) {
    return langs;
  }

  const replacement: Record<string, string> = {
    BIGO: 'PartyHero',
    Bigo: 'PartyHero',
    bigo: 'partyhero',
  };

  const result: Record<string, string> = {};

  Object.keys(langs).forEach((key) => {
    result[key] = doReplacement(langs[key], replacement);
  });

  return result;
};

/**
 * 在 partyHero 皮肤包下，对多语言文本进行品牌替换。
 * window.doInstallPackageReplace 由皮肤包注入，接受字符串并返回替换后的字符串。
 */
const applyPartyHeroReplace = (langs: Record<string, string>): Record<string, string> => {
  if (!isPartyHero() || typeof window.doInstallPackageReplace !== 'function') {
    return langs;
  }
  try {
    const replaced = window.doInstallPackageReplace(JSON.stringify(langs));
    const parsedLangs = JSON.parse(replaced);
    // 补充处理 BIGO 文案
    return applyBigoToPartyHeroReplace(parsedLangs);
  } catch {
    return langs;
  }
};

export const loadPearLocale = async (id: number, lang: string) => {
  const url = await getReplaceDomain('https://static-web.bigolive.tv');
  const langs = await fetchData(
    `${url}/as/common-static/pear/prod/${
      prefixMap[pearConfigEnv]
    }${id}-${lang}.json?t=${Date.now()}`,
  );

  return applyPartyHeroReplace(langs);
};

export const loadPearConfig = async (id: number) => {
  const url = await getReplaceDomain('https://static-web.bigolive.tv');
  const configs = await fetchData(
    `${url}/as/common-static/pear/prod/${prefixMap[pearConfigEnv]}${id}.json?t=${Date.now()}`,
  );
  return configs;
};
